import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Shield, Clock } from 'lucide-react';
import Logo from './Logo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-slate-900 text-slate-300 border-t border-slate-800 overflow-hidden">
      {/* Baggrundsbillede med mørkt overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://assets.auxodev.dk/assets/b4f7e7e4-b57e-4a68-b3f8-2a4e7f0b8617/tagrenovering-entreprenoer-sjaelland-toa-byg.jpg" 
          alt="Toa Byg ApS tagarbejde og tagrenovering på Sjælland" 
          className="w-full h-full object-cover opacity-45 filter brightness-90"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/80 to-slate-900/85" />
      </div>

      {/* Hovedindhold i footer */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Kolonne 1: Om Toa Byg ApS */}
          <div className="space-y-4">
            <Logo light={true} className="h-10" />
          </div>

          {/* Kolonne 2: Hurtige links */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Hurtige links</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">Forside</Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-white transition-colors">Galleri</Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-white transition-colors">Om os</Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-white transition-colors">Kontakt</Link>
              </li>
            </ul>
          </div>

          {/* Kolonne 3: Vores Ydelser */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Vores Ydelser</h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/ydelser/tagarbejde" className="hover:text-white transition-colors">Tagarbejde</Link>
              </li>
              <li>
                <Link to="/ydelser/tagrenovering" className="hover:text-white transition-colors">Tagrenovering</Link>
              </li>
              <li>
                <Link to="/ydelser/renovering" className="hover:text-white transition-colors">Renovering</Link>
              </li>
              <li>
                <Link to="/ydelser/toemrerarbejde" className="hover:text-white transition-colors">Tømrerarbejde</Link>
              </li>
              <li>
                <Link to="/ydelser/entrepriseopgaver" className="hover:text-white transition-colors">Entrepriseopgaver</Link>
              </li>
            </ul>
          </div>

          {/* Kolonne 4: Kontakt & Åbningstider */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-2">Kontakt os</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <MapPin className="h-5 w-5 text-white shrink-0 mt-0.5" />
                <span>Baldersbækvej 24, 2635 Ishøj</span>
              </li>
              <li className="flex items-center gap-2.5">
                <Phone className="h-5 w-5 text-white shrink-0" />
                <a href="tel:+4540942420" className="hover:text-white transition-colors">+45 40 94 24 20</a>
              </li>
              <li className="flex items-center gap-2.5">
                <Mail className="h-5 w-5 text-white shrink-0" />
                <a href="mailto:toabyg1@gmail.com" className="hover:text-white transition-colors">toabyg1@gmail.com</a>
              </li>
              <li className="flex items-start gap-2.5 pt-2 border-t border-slate-800">
                <Clock className="h-5 w-5 text-white shrink-0 mt-0.5" />
                <div className="text-xs text-slate-400">
                  <p className="font-semibold text-slate-300">Mandag - Fredag:</p>
                  <p>07:00 - 16:00</p>
                  <p className="font-semibold text-slate-300 mt-1">Lørdag - Søndag:</p>
                  <p>Lukket (Akut tagarbejde efter aftale)</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bund-bar */}
      <div className="relative z-10 bg-slate-950/90 text-slate-500 text-xs py-6 border-t border-slate-900/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div>
            © {currentYear} Toa Byg ApS · CVR: 12345678 · Alle rettigheder forbeholdes.
          </div>
          <div className="flex gap-4">
            <span className="hover:text-slate-400 transition-colors">Privatlivspolitik</span>
            <span>·</span>
            <span className="hover:text-slate-400 transition-colors">Cookiepolitik</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
